var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"usdt_wrap"},[_c('div',{staticClass:"red_top_bg"},[_c('div',{staticClass:"back_left",on:{"click":function($event){return _vm.$router.push('/user')}}}),_c('div',{staticClass:"big_tit"},[_vm._v(_vm._s(_vm.data.payment.name))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }